import { get } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { getFormInitialValues, getFormValues, isPristine, isSubmitting } from 'redux-form';
import { chargerConfigurationFormId } from './components/ChargerConfiguration/constants';

const extractModifiedValues = (values, initialValues) =>
  Object.keys(initialValues).reduce((list, key) => {
    const initialValue = initialValues[key];
    const value = values[key];

    if (!!initialValue && !!value && initialValue !== value) {
      list[key] = value;
    }

    return list;
  }, {});

export const getViewedChargerData = (state) => get(state, 'chargerDetails') || {};

export const getViewedChargerUuid = createSelector(
  [(state) => getViewedChargerData(state)],
  (value) => get(value, 'currentCharger.c_uuid') || {},
);

export const getViewedChargerConfiguration = createSelector([(state) => getViewedChargerData(state)], (value) =>
  get(value, 'configuration'),
);

export const getViewedChargerConfigurationParametersByStatus = createSelector(
  [(state) => getViewedChargerConfiguration(state), (state, status) => status],
  ({ nodes }, status) =>
    nodes.reduce((collectingParams, node) => {
      const { node_name: nodeName, groups } = node;

      groups.forEach((group) => {
        collectingParams = collectingParams.concat(
          group.parameters
            .filter((param) => param.status === status)
            .map((param) => ({ ...param, node_name: nodeName, group_name: group.group_name })),
        );
      });

      return collectingParams;
    }, []),
);

export const getViewedChargerFieldsPathMap = createSelector([(state) => getViewedChargerData(state)], (value) =>
  get(value, 'fieldsPathMap'),
);

export const getChargerConfigurationFormData = createSelector(
  [
    (state) => getFormValues(chargerConfigurationFormId)(state),
    (state) => getFormInitialValues(chargerConfigurationFormId)(state),
    (state) => isPristine(chargerConfigurationFormId)(state),
    (state) => isSubmitting(chargerConfigurationFormId)(state),
  ],
  (values, initialValues, pristine, submitting) => ({
    values,
    initialValues,
    modifiedValues: extractModifiedValues(values, initialValues),
    pristine,
    submitting,
  }),
);

export const getSSPData = (state, sspId, defaultValue) => get(state, `ssplists.${sspId}.data`, defaultValue);
export const getDiagnosticAvailable = (state) => get(state, 'chargerDetails.isDiagnosticsAvailable', false);
export const getCurrentChargerCustomerId = (state) => get(state, 'chargerDetails.currentCharger.customer.customerId');
export const selectIsConfigurationLockedByAnotherUser = (state) => get(state, 'chargerDetails.isConfigurationLockedByAnotherUser', false);
export const selectResetCommand = (state) => get(state, 'chargerDetails.resetCommand', '');
export const selectLockedConfigurationIds = (state) => get(state, 'chargerDetails.lockedIds', null);